module.exports = __webpack_public_path__ + "img/english.742add0c.png";